import { Component, OnInit } from '@angular/core';
@Component({
  selector: 'app-opekepe-login',
  templateUrl: './opekepe-login.component.html',
  styleUrls: ['./opekepe-login.component.scss']
})
export class OpekepeLoginComponent implements OnInit {

  constructor() { }

  ngOnInit() {}
}
